import { FrameStore } from "@/modules/base";
import { Component, Prop, Vue } from "vue-property-decorator";
import { CatalogOverplotModule } from "..";
import { CatalogOverplot } from "../CatalogOverplot";
import { MarkerStyle } from "../Marker/marker";
// tslint:disable-next-line:no-var-requires
const sampleCsv = require('file-loader?name=sample.csv!./sample.csv') as string

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: CatalogOverplotModule

  @Prop({ required: true })
  frameStore!: FrameStore<typeof CatalogOverplotModule>

  async fileSelect(e: Event) {
    e.preventDefault();
    const files: FileList = (e.target as any).files
    for (let i = 0; i < files.length; ++i) {
      await this.module.loadFile(files.item(i)!)
    }
    (this.$refs.form as HTMLFormElement).reset();
  }

  remove(co: CatalogOverplot) {
    if (true || confirm(`Are you sure to remove "${co.name.trim()}" from catalog list?`)) {
      const index = this.frameStore.cos.indexOf(co)
      this.frameStore.cos.splice(index, 1)
    }
  }

  get sampleCsvPath() {
    return sampleCsv
  }

  get markers() {
    return Object.keys(MarkerStyle)
  }
}
